<template>
  <a-drawer
    :title="title"
    :visible="open"
    width="860"
    @close="onClose"
  >
    <a-spin :spinning="loading">
      <a-table
        rowKey="id"
        size="small"
        :columns="columns"
        :data-source="list"
        :pagination="false"
      >
        <span slot="beforeAmount" slot-scope="text">
          {{ formatMoney(text) }}
        </span>
        <span slot="afterAmount" slot-scope="text">
          {{ formatMoney(text) }}
        </span>
        <span slot="createTime" slot-scope="text">
          {{ parseTime(text) }}
        </span>
      </a-table>
      <a-pagination
        v-if="total > 0"
        class="ant-table-pagination"
        style="margin-top: 16px; text-align: right"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="t => `共 ${t} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-spin>
  </a-drawer>
</template>

<script>
import { pageUserAmountModifyLogs } from '@/api/biz/user'

export default {
  name: 'AmountModifyLogs',
  data() {
    return {
      open: false,
      loading: false,
      title: '金额修改记录',
      list: [],
      total: 0,
      queryParam: {
        userId: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        { title: '字段', dataIndex: 'fieldLabel', width: 140 },
        { title: '修改前', dataIndex: 'beforeAmount', scopedSlots: { customRender: 'beforeAmount' }, align: 'right', width: 120 },
        { title: '修改后', dataIndex: 'afterAmount', scopedSlots: { customRender: 'afterAmount' }, align: 'right', width: 120 },
        { title: '操作人', dataIndex: 'operatorName', width: 120 },
        { title: '备注', dataIndex: 'remark', ellipsis: true },
        { title: '时间', dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' }, width: 170 }
      ]
    }
  },
  methods: {
    formatMoney(val) {
      if (val == null || val === '') return '—'
      const num = Number(val)
      if (Number.isNaN(num)) return val
      return num.toFixed(2)
    },
    onClose() {
      this.open = false
      this.list = []
      this.total = 0
    },
    handleOpen(record) {
      const name = (record && (record.nickname || record.email || record.id)) || ''
      this.title = `金额修改记录 - ${name}`
      this.queryParam = {
        userId: record.id,
        pageNum: 1,
        pageSize: 10
      }
      this.open = true
      this.getList()
    },
    getList() {
      if (!this.queryParam.userId) return
      this.loading = true
      pageUserAmountModifyLogs(this.queryParam).then(res => {
        this.list = (res.data && res.data.records) || []
        this.total = (res.data && res.data.total) || 0
      }).finally(() => {
        this.loading = false
      })
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    }
  }
}
</script>
